import { useTranslation } from '@hooks/useTranslation';
import { Box, Typography } from '@mui/material';

interface SwitchOrganizationModalProps {
  organizationName: string;
}

const SwitchOrganizationModal: React.FC<SwitchOrganizationModalProps> = ({ organizationName }) => {
  const localeProcesses = useTranslation('processes');

  return (
    <Box className="flex flex-col gap-2">
      <Typography variant="body16">
        {localeProcesses['processFoundInOtherOrg'].replace('{organizationName}', organizationName)}
      </Typography>
      <Typography variant="body14" className="text-gray-600">
        {localeProcesses['switchToOrganization']}
      </Typography>
    </Box>
  );
};

export default SwitchOrganizationModal;
